<template>
  <div class="about">
    <header-view curr="4"></header-view>
    <div class="bodyer">
      <div class=" subtitle">
        <div class="left"></div>
        <div class="title">捐助记录</div>
      </div>
      <div class="hr"></div>
      <div class="from">
        <div class="tableheader">
          <div class="tableheaderbox">
            <div class="name">日期范围：</div>
            <span class="inp">
              <DatePicker class="" :openPanelFun="openPanelF0"></DatePicker>
              <div class="icon hover" @click="dateFun('0')"></div>
            </span>

            <div class="name zhi">至</div>

            <span class="inp">
              <DatePicker class="" :openPanelFun="openPanelF1"></DatePicker>
              <div class="icon hover" @click="dateFun('1')"></div>
            </span>

            <div class="name">项目：</div>
            <div class="select">
              <select>
                <option
                  v-for="(item, index) in selectList"
                  :value="item.id"
                  @change="change"
                  >{{ item.title }}</option
                >
              </select>
            </div>
            <div class="btn hand">查询</div>
          </div>
        </div>
        <table>
          <th>日期</th>
          <th>捐助项目</th>
          <th>捐助方式</th>
          <th>捐助金额</th>
          <th>捐助人</th>
          <!-- <th>状态</th> -->
          <tr v-for="(item, index) in list" :key="index">
            <td>{{ item.donationDate }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.donationType_dictText }}</td>
            <td>{{ item.money }}</td>
            <td>{{ item.donationUserId_dictText }}</td>
            <!--  <td :class="item.start == 1 ? 'act' : ''">
              {{ item.start == 1 ? "捐助中" : "已到账" }}
            </td> -->
          </tr>
        </table>

        <zhini-pagination
          :currentPage="pageNo"
          :totalPage="totalPage"
          @pageNum="pageNum"
        ></zhini-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import titleview from "../components/titleview.vue";
import headerView from "../components/header.vue";
import DatePicker from "../components/DatePicker.vue";
import zhiniPagination from "../components/zhini-pagination.vue";
export default {
  components: {
    headerView,
    titleview,
    DatePicker,
    zhiniPagination
  },
  data: function() {
    return {
      openPanelF0: false,
      openPanelF1: false,
      list: [],
      selectList: "",
      pageNo: 1,
      pageSize: 10,
      totalPage: 0
    };
  },
  mounted() {
    // this.makeCode(this.identifyCodes, 4);
  },
  created() {
    this.initselectList();
    this.init();
  },
  methods: {
    initselectList() {
      var that = this;
      this.httpGet("web/thpDonationActivity/list", {
        // activityId
      }).then(res => {
        that.selectList = res.result;
      });
    },
    init() {
      //
      var that = this;
      this.httpGet("web/donation/thpDonationRecord/list", {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then(res => {
        that.list = res.result.records;
        that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    dateFun(index) {
      if (index == 0) {
        this.openPanelF0 = !this.openPanelF0;
      } else {
        this.openPanelF1 = !this.openPanelF1;
      }
    },
    change(e) {
      console.log(e);
    },
    pageNum(e) {
      console.log(e);
      this.pageNo = e;
      this.init();
    }
  }
};
</script>

<style scoped lang="scss">
th,
td,
tr,
table {
  margin: auto;
  padding: 0;
}
.about {
  // min-height: 100vh;
  height: auto;
}
.bodyer {
  width: 15.75rem;
  // height: 100%;
  // min-height: 9rem;
  background: #ffffff;
  margin: 0.6rem auto 0;
  overflow: hidden;
}
// .titleview {
//   margin: 0.4rem auto 0.3rem 0.23rem;
//   width: 100%;
//   >>> .text {
//     color: #171717;
//   }
// }
.subtitle {
  background: #ffffff;
  font-size: 0.18rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #171717;
  overflow: hidden;
  .left {
    width: 0.05rem;
    height: 0.2rem;
    background: #e61f26;
    margin: 0.28rem 0.24rem;
  }
  .title {
    float: left;
    color: #171717;
    margin-top: 0.28rem;
  }
}

.hr {
  width: 100%;
  height: 0.02rem;
  background: #ebf0f5;
}
.from {
  margin-bottom: 0.9rem;

  .tableheader {
    padding: 0.3rem 0;
    // overflow: hidden;
    // height: 1.16rem;
    width: 100%;
    margin: 0 auto;
    border-bottom: 0.1rem solid #ebf0f5;
    .tableheaderbox {
      width: 15.29rem;
      height: 0.54rem;
      background: #f8f8f8;
      border: 0.01rem solid #eaeaea;
      border-radius: 0.06rem;
      margin: 0 auto;
      position: relative;
      // display: flex;
      & > div,
      & > span {
        float: left;
      }
      .btn {
        width: 0.9rem;
        height: 0.36rem;
        background: #fbfbfb;
        border: 0.01rem solid #dfe2e7;
        margin-top: 0.09rem;
        line-height: 0.36rem;
        text-align: center;
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #e61f26;
        display: inline-block;
      }
      .select {
        width: 1rem;
        height: 0.36rem;
        border: 0.01rem solid #dfdfdf;
        border-radius: 0.02rem;
        overflow: hidden;
        position: relative;
        margin-top: 0.09rem;
        margin-right: 0.5rem;
        background: #ffffff;
      }
      select {
        width: 0.89rem;
        height: 0.36rem;
        padding-left: 0.11rem;
        display: inline-block;
        border: none;
        option {
          margin-top: 0.05rem;
          padding: 0 0.11rem;
        }
      }
      .name {
        line-height: 0.54rem;
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #171717;
        padding: 0 0.2rem;
      }
      .zhi {
        padding: 0 0.14rem;
      }
      .inp {
        width: 2rem;
        height: 0.36rem;
        padding-left: 0.16rem;
        background: #ffffff;
        border: 0.01rem solid #dfe2e7;
        margin-top: 0.09rem;
        position: relative;
        .icon {
          position: absolute;
          top: 0.09rem;
          right: 0.12rem;
          width: 0.23rem;
          height: 0.19rem;
          background: url(../assets/rl.png) no-repeat center / 100% 100%;
        }
      }
    }
  }
  table {
    width: 100%;
    line-height: 0.54rem;
    border-collapse: collapse;
    font-size: 0.16rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1b1b1b;
    th {
      background: #f8f8f8;
    }
    tr {
      background: #ffffff;
      border-bottom: 1px solid #bbbbbb;
      td {
        border-right: 1px solid #ebf0f5;
        text-align: center;
      }
      .act {
        color: #e61f26;
      }
      td:last-child {
        border: none;
      }
    }
  }
}
</style>
